<template>
  <div class="app-dropdown"
       :class="{'active': show}"
       v-click-outside="hideDropdown"
  >
    <div class="app-dropdown__label"
         tabindex="0"
         @click="toggleDropdown"
    >
      <p class="app-dropdown__label__title">{{ title }}</p>

      <slot name="label"></slot>

      <app-icon icon="arrow-down-triangle"
                class="app-dropdown__label__arrow-down"
      />
    </div>

    <transition name="fade">
      <div v-if="show"
           class="app-dropdown__dropdown"
      >
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "AppDropdown",
  props: {
    title: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      show: false
    }
  },
  methods: {
    toggleDropdown() {
      this.show = !this.show
    },
    hideDropdown() {
      this.show = false
    }
  },
  watch: {
    show: function (show) {
      if (show)  {
        this.$emit('open')
      } else {
        this.$emit('close')
      }
    }
  }
}
</script>

<style lang="scss">
.app-dropdown {
  position: relative;
  margin: 0 9px;

  &__label {
    position: relative;
    display: flex;
    justify-content: space-between;
    height: 58px;
    width: 280px;
    background-color: $input-background-color;
    padding: 5px 25px 5px 10px;
    cursor: pointer;

    &:after {
      content: "";
      position: absolute;
      left: $dropdown-separator-paddings;
      right: $dropdown-separator-paddings;
      bottom: 0;
      height: 1px;
      background-color: rgba($input-placeholder-color, 0);
      transition: background-color .3s;
    }

    &__title {
      font-family: "DINCondensed", sans-serif;
      font-size: 2.5em;
      font-weight: 700;
      color: $input-title-color;
      transition: color .3s;
    }

    &__arrow-down {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
    }

  }

  &__dropdown {
    position: absolute;
    top: 100%;
    min-width: 100%;
    background-color: $input-background-color;
    z-index: 10;
  }

  .active &__label {

    &__title {
      color: $app-primary-color;
    }

    &:after {
      background-color: $input-placeholder-color;
    }

  }

}

@include smallerThan("xxl") {
  .app-dropdown {
    &__label {
      width: 200px;

      &__title {
        font-size: 2em;
        line-height: 1.5em;
      }
    }
  }
}

@include smallerThan("lg") {
  .app-dropdown {
    &__label {
      width: 100%;
    }
  }
}
</style>
